import React, { useState } from "react";
import { Flex, SimpleGrid } from "@chakra-ui/react";
import ElasticPerformanceBanner from "./ElasticPerformanceBanner";
import ElasticStatusCard from "./ElasticStatusCard";
import ElasticIndexCard from "./ElasticIndexCard";
import ElasticMigrationCard from "./ElasticMigrationCard";

/**
 * Main ElasticSearch monitoring page with performance banner, status, index, and migration cards.
 * @returns {React.ReactElement}
 */
function ElasticSearch() {
    const [statusData, setStatusData] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    return (
        <Flex direction="column" gap="20px">
            <ElasticPerformanceBanner refreshTrigger={refreshTrigger} />
            <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="20px">
                <ElasticStatusCard
                    refreshTrigger={refreshTrigger}
                    onRefresh={() => setRefreshTrigger((prev) => prev + 1)}
                    onDataUpdate={setStatusData}
                />
                <ElasticIndexCard
                    refreshTrigger={refreshTrigger}
                    onRefresh={() => setRefreshTrigger((prev) => prev + 1)}
                />
            </SimpleGrid>
            <ElasticMigrationCard
                statusData={statusData}
                onMigrationComplete={() => setRefreshTrigger((prev) => prev + 1)}
            />
        </Flex>
    );
}

export default ElasticSearch;
